import { SET_UNRESOLVED_INCIDENTS_COUNT } from '../actions/types';
import type { ActionWithPayload } from '../../types';

export function unresolvedIncidentsCountReducer(state: number = 0, action: ActionWithPayload): number {
  switch (action.type) {
    case SET_UNRESOLVED_INCIDENTS_COUNT:
      return action.payload;
    default:
      return state;
  }
}
